import React from 'react';
import { Routes, Route, Navigate, Link } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, LoginOauth } from './components';
import { RegistrationPage, ForgotPasswordPage, NewResetPasswordPage } from './pages';

export const UnauthenticatedContent = () => {
  return (
    <Routes>
      <Route
        path='/login'
        element={
          <SingleCard title='Sign In'>
            <LoginForm />
            <LoginOauth />
            <div className='login-footer'>
              <div className='create-account-link'>
                <Link to='/create-account'>Account aanmaken</Link>
              </div>
            </div>
          </SingleCard>
        }
      />
      <Route
        path='/create-account'
        element={<RegistrationPage />}
      />
      <Route
        path='/forgot-password'
        element={<ForgotPasswordPage />}
      />
      <Route
        path='/reset-password'
        element={<NewResetPasswordPage />}
      />
      <Route path='*' element={<Navigate to='/login' />} />
    </Routes>
  );
};
